import { toGsResponse } from '../../goodstack'
import { PartnerConfig } from '../../config/config.types'

import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type GetPartnerAllowlistedVolunteeringCountriesResponse = {
  data: {
    allowlisted_countries_for_volunteering?: PartnerConfig<
      'allowlisted_countries_for_volunteering',
      { countryCodes: string[] }
    >
  }
  object: string
}

export const getPartnerAllowlistedVolunteeringCountries: QueryFn<[string], string[]> = async (client, _) => {
  const response = await client
    .get<GetPartnerAllowlistedVolunteeringCountriesResponse>(`v1/partner/volunteering/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)

  return response?.data.allowlisted_countries_for_volunteering?.value?.countryCodes ?? []
}
